module.exports = __webpack_public_path__ + "img/performax.9586f372.svg";